/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './FileInput.scss'
import React, { Component } from 'react'
import Icon from '../icon/Icon'
import DeleteIcon from '../icon/DeleteIcon'
import r from '../../../util/Renderer'

let ___FileInput__counter___ = 0

class FileInput extends Component {
  constructor(props) {
    super(props)
    this.guid = 'file-input-' + ___FileInput__counter___++
  }

  render() {
    const className = this.props.className || ''
    const name = this.props.name || ''
    const isEmpty = !this.props.label
    const borderStyle = isEmpty ? { border: 'solid 1px #a2a2a2' } : { border: 'none' }
    const label = this.props.label || this.props.default || 'アップロード'
    const onChange = this.props.onChange || (() => {})
    const onClear = this.props.onClear || (() => {})
    const accept = this.props.accept || '*'
    const guid = this.guid
    const isDialog = (!isEmpty && this.props.isDialog) || false
    const isDisplay = (!isEmpty && this.props.isDisplay) || false
    const onDisplay = isDisplay ? this.props.onDisplay : () => {}

    return (
      <div className={`FileInput ${className}`}>
        {r.renderIf(this.props.type)(
          <div className="FileInput__type">
            <Icon type={this.props.type} onClick={e => onDisplay(e)} />
          </div>
        )}
        <label className="FileInput__fileArea" style={borderStyle} htmlFor={guid}>
          <span className="FileInput__message" onClick={e => onDisplay(e)}>
            {r.renderIfOrElse(isDisplay)(<a href={''}>{label}</a>)(label)}
          </span>
          <input id={guid} className={'FileInput__file'} type="file" name={name} accept={accept} onChange={e => onChange(e)} disabled={!isEmpty} />
        </label>
        {r.renderIfOrElse(isDialog)(
          <div className="FileInput__trash">
            {/* 同一ファイルを再アップロードする場合 onChangeが実行されないので、ここで value をクリアしておく */}
            <DeleteIcon
              onClick={e => {
                document.getElementById(guid).value = ''
                onClear(e)
              }}
            >
              削除
            </DeleteIcon>
          </div>
        )(
          <div className="FileInput__trash">
            <Icon
              type="trash"
              onClick={e => {
                document.getElementById(guid).value = ''
                onClear(e)
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

export default FileInput
